declare namespace $ {

	type $mol_text__text_bog_quiz_session_join_1 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_join['quiz_info_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_bog_quiz_session_join_2 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_join['participant_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_quiz_session_join_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_major__click_bog_quiz_session_join_4 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_join['join'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_bog_quiz_session_join_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_bog_quiz_session_join_6 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_join['can_join'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_list__rows_bog_quiz_session_join_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $bog_quiz_session_join extends $mol_page {
		quiz_info_text( ): string
		Quiz_info( ): $mol_text
		participant_name( next?: string ): string
		Name_field( ): $mol_string
		join( next?: any ): any
		can_join( ): boolean
		Join_button( ): $mol_button_major
		Join_form( ): $mol_list
		session_id( ): string
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=join.view.tree.d.ts.map